export interface EventSaveError {
  title: string;
  details: string[];
}

function validationMessages(value: unknown): string[] {
  if (typeof value === "string") {
    const message = value.trim();
    // Error pages and stack traces are not useful validation messages.
    if (
      !message ||
      /<[^>]+>|\b(?:SELECT|INSERT INTO|UPDATE .+ SET)\b/i.test(message)
    )
      return [];
    return [
      message
        .replace(
          /Event category must exist/g,
          "Selecione uma categoria válida para o evento.",
        )
        .replace(
          /Start date cannot be in the past/g,
          "A data de início do evento não pode estar no passado.",
        ),
    ];
  }
  if (Array.isArray(value)) return value.flatMap(validationMessages);
  if (!value || typeof value !== "object") return [];
  return Object.entries(value).flatMap(([field, messages]) => {
    const label: Record<string, string> = {
      base: "",
      title: "Nome do evento",
      description: "Descrição",
      event_category: "Categoria",
      event_category_id: "Categoria",
      start_date: "Início do evento",
      end_date: "Término do evento",
    };
    return validationMessages(messages).map((message) =>
      field === "base" ? message : `${label[field] ?? field}: ${message}`,
    );
  });
}

/** Read public validation fields, never HttpErrorResponse.message or a server error page. */
export function describeEventSaveError(
  error: unknown,
  creating: boolean,
): EventSaveError {
  const failure =
    error && typeof error === "object"
      ? (error as { status?: number; error?: unknown })
      : {};
  const title = creating
    ? "Não foi possível criar o evento."
    : "Não foi possível atualizar o evento.";
  const status = failure.status;
  if (status === 0)
    return {
      title,
      details: [
        "Não foi possível confirmar a resposta do servidor. Verifique sua conexão e consulte Meus eventos antes de tentar salvar novamente.",
      ],
    };
  if (status === 401)
    return {
      title,
      details: ["Sua sessão expirou. Entre novamente para salvar o evento."],
    };
  if (status === 403)
    return {
      title,
      details: ["Você não tem permissão para salvar este evento."],
    };
  if (
    status &&
    status >= 400 &&
    status < 500 &&
    failure.error &&
    typeof failure.error === "object"
  ) {
    const body = failure.error as {
      error?: unknown;
      errors?: unknown;
      message?: unknown;
    };
    const details = [
      ...new Set(validationMessages(body.errors ?? body.error ?? body.message)),
    ];
    if (details.length) return { title, details };
  }
  return {
    title,
    details: [
      status && status >= 500
        ? `O servidor apresentou uma falha (HTTP ${status}). Consulte Meus eventos antes de tentar salvar novamente, para evitar duplicidade.`
        : "O servidor não informou o motivo da falha. Consulte Meus eventos antes de tentar salvar novamente.",
    ],
  };
}
